/** Auth form field styling — uses MUI theme tokens for light/dark compatibility. */
export const textFieldStyle = {
  '& .MuiInputBase-root': {
    borderRadius: '12px',
    bgcolor: 'background.paper',
  },
  '& .MuiInputBase-input': {
    py: 1.5,
  },
  '& .MuiInputLabel-root': { color: 'text.secondary' },
  '& .MuiInputLabel-root.Mui-focused': { color: 'primary.main' },
  '& .MuiOutlinedInput-root': {
    '& fieldset': { borderColor: 'divider' },
    '&:hover fieldset': { borderColor: 'primary.main' },
    '&.Mui-focused fieldset': {
      borderColor: 'primary.main',
      borderWidth: '1.5px',
    },
  },
};

export const authPrimaryButtonSx = {
  mt: 2.5,
  mb: 0.5,
  minHeight: 48,
  borderRadius: '12px',
  fontWeight: 700,
  fontSize: '0.9375rem',
  letterSpacing: '0.01em',
  textTransform: 'none',
  boxShadow: 'none',
  '&:hover': {
    boxShadow: '0 6px 16px rgba(232, 114, 114, 0.28)',
  },
};
